module.exports = __webpack_public_path__ + "fonts/Fasthand-Regular.3a1d9b0.ttf";